import { Region } from '@lemon8/web-app-shared/i18n';

export const ImageRegion: any = {
  [Region.jp]: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/d6af822f826e4490b79700339c9515f4',
  [Region.vn]: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/dd8085e28e0e4328bb624f8477b76076',
  [Region.sg]: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/dd8085e28e0e4328bb624f8477b76076',
  [Region.th]: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/9de856bc827a47d7a5ca2c2157d18e8b',
  [Region.gb]: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/dd8085e28e0e4328bb624f8477b76076',
  [Region.us]: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/dd8085e28e0e4328bb624f8477b76076',
  default: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/dd8085e28e0e4328bb624f8477b76076',
};
export const ACTIVITY_PID = 'ideabuckets';

// start with snssdk2657
// TDOD: remember to change the url
export const schema =
  'snssdk2657://webview?url=https%3A%2F%2Flf16-sourcecdn-tos.ibytedtos.com%2Fobj%2Fbyte-gurd-source-sg%2F62%2Fgecko%2Fresource%2F100ideas%2Fhtml%2Flanding-page.html%3Fposition%3Dwap&hide_navigation_bar=1&allow_change_statusbar=1&disable_bounces=1';
